// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J-Ki","questions":"styles_questions__KjduK","footer":"styles_footer__3XGPq"};